import React from 'react'

import type { CallToActionBlock as CTABlockProps } from '@/payload-types'

import type { LexicalRichTextBody } from '@/components/RichText/blockConvertersTypes'
import { CMSLink } from '@/components/Link'

type Props = CTABlockProps & {
  lexicalRichText: LexicalRichTextBody
  /** Repositório de layout; não afecta o CTA. */
  disableInnerContainer?: boolean
}

export const CallToActionBlock: React.FC<Props> = ({
  links,
  richText,
  lexicalRichText: Lexical,
  disableInnerContainer: _omit,
}) => {
  return (
    <div className="container">
      <div className="bg-card rounded border-border border p-4 flex flex-col gap-8 md:flex-row md:justify-between md:items-center">
        <div className="max-w-3xl flex items-center">
          {richText && <Lexical className="mb-0" data={richText} enableGutter={false} />}
        </div>
        <div className="flex flex-col gap-8">
          {(links || []).map(({ link }, i) => {
            return <CMSLink key={i} size="lg" {...link} />
          })}
        </div>
      </div>
    </div>
  )
}
